import Traslation from '../../models/translations.model';
import {createSlice} from '@reduxjs/toolkit';

export interface TranslationState{
  translation:Traslation|undefined,
  loading:boolean,
  error:any
}


const initialState:TranslationState = {
  translation:undefined,
  loading:false,
  error:undefined
}

const translationSlice = createSlice({
  name:'translation',
  initialState:initialState,
  reducers:{

    fetchTranslationRequest(state){
      state.loading = true;
    },

    fetchTranslationSuccess(state,actions){
      state.loading = false;
      state.translation = actions.payload;
    },

    fetchTranslationFail(state,actions){
      state.loading = false;
      state.error = actions.payload;
    }
  }
});

export const {
  fetchTranslationFail,
  fetchTranslationRequest,
  fetchTranslationSuccess
}  = translationSlice.actions;


export default translationSlice.reducer;